<template>
  <div class="top-header">
    <!-- <div class="right-btn font-bold" @click="handleDetail">详情</div> -->
    <div class="right-btn font-bold">
      <el-button type="primary" plain @click="handleDetail">详情</el-button>
    </div>
    <img style="border-radius: 50%" src="../datav/img/head.png" alt="" />
    <div>
      <div class="name">
        {{ archive.name }}
      </div>
      <div class="flex text-sm">
        <div class="mr-5">{{ archive.age }}岁</div>
        <div class="flex items-center">
          <template v-if="archive.gender == 1">
            <img
              class="gender-img"
              src="../datav/img/icon-gender-1.png"
              alt=""
            />
            <div>男性</div>
          </template>
          <template v-else>
            <img
              class="gender-img"
              src="../datav/img/icon-gender-2.png"
              alt=""
            />
            <div>女性</div>
          </template>
        </div>
      </div>
      <div class="mt-1">
        <el-button
          :type="getLevelBtn(archive.riskLevel).type"
          class="plain"
          style="font-size: 10px; padding: 6px 14px"
          >{{ getLevelBtn(archive.riskLevel).name }}</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { formatRiskLevel } from "../../utils/index";

export default {
  data() {
    return {};
  },
  props: {
    archive: {
      type: Object,
      default: () => {},
    },
    sn: {
      type: String,
      default: "",
    },
  },
  methods: {
    async handleDetail() {
      if (!this.sn) return;
      let accessToken = await this.$store.dispatch("app/getToken");
      let link = `${process.env.VUE_APP_ARCHIVES_DOMAIN}?accessToken=${accessToken}&&key=${this.sn}`;
      window.open(link);
    },
    getLevelBtn(level = 0) {
      let list = [
        {
          type: "success",
          name: formatRiskLevel(level),
        },
        {
          type: "success",
          name: formatRiskLevel(level),
        },
        {
          type: "warning",
          name: formatRiskLevel(level),
        },
        {
          type: "danger",
          name: formatRiskLevel(level),
        },
      ];
      console.log(list[level]);
      return list[level];
    },
  },
};
</script>
<style lang="less" scoped>
.top-header {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 80px;
  color: #333 !important;
  position: relative;
  background: @background-color !important;
  .right-btn {
    position: absolute;
    right: 50px;
    top: 10px;
  }
  img {
    width: 74px;
    height: 74px;
    margin-right: 10px;
  }
  .name {
    font-size: 20px;
    font-weight: bold;
  }
  // background: linear-gradient(-90deg, #0e2f4e 0%, #0a1828 100%);
}
.gender-img {
  width: 16px !important;
  height: 16px !important;
}
</style>
